import { imageProvider } from './config/imageProvider/imageProviderConfig';
import { redirect } from './redirect';

const version = new Date().getTime();
export const BASE_URL = process.env.BASE_API_URL;
export const BASE_API_URL = `${BASE_URL}/api/`;
// eslint-disable-next-line max-len,vue/max-len
export const CONF_TOKEN = 'a26ac89e14e68c5f8f1e1246622b88ec83774411009035bbd95e614acebf9f553EuOp-e0m40lWWyqx8T7ZW6ToSLUFnVf';

export default {
  modern: process.env.ENVIRONMENT === 'production',
  server: {
    port: 3015,

  },
  // Global page headers: https://go.nuxtjs.dev/config-head
  head: {
    title: '2000koles',
    htmlAttrs: {
      lang: 'ru',
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1, user-scalable=no' },
      { hid: 'metadescription', name: 'description', content: '' },
    ],
    link: [
      // { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
      // { rel: 'preload', as: 'image', href: '/_nuxt/static/images/header-menu-icon.svg' },
      // { rel: 'preload', as: 'image', href: '/_nuxt/static/images/header-logo.svg' },
      // { rel: 'preload', as: 'image', href: '/_nuxt/static/images/header-whatsapp.svg' },
      // { rel: 'preload', as: 'image', href: '/_nuxt/static/images/header-telegram.svg' },
      // { rel: 'preload', as: 'image', href: '/_nuxt/static/images/header-search.svg' },
      // { rel: 'preload', as: 'image', href: '/_nuxt/static/images/header-phone-white.svg' },
      // { rel: 'preload', as: 'image', href: '/_nuxt/static/images/header-cart.svg' },
    ],
    script: [
      {
        type: 'text/javascript', body: true, src: '/js/sourcebuster.min.js', async: true,
      },
      {
        type: 'text/javascript', body: true, src: '/js/forma.tinkoff.js', async: true,
      },
      //{
      //  type: 'text/javascript', body: true, src: '/js/team.js', async: true,
      //},
    ],
  },

  // Global CSS: https://go.nuxtjs.dev/config-css
  css: [
    '~/assets/scss/main.scss',
  ],

  // Plugins to run before rendering page: https://go.nuxtjs.dev/config-plugins
  plugins: [
    { src: '~/plugins/Vuelidate.js' },
    { src: '~plugins/vue-range-slider.js', ssr: false },
    { src: '~/plugins/vue-datepicker', ssr: false }, // datepicker plugin here

    '~plugins/vue-mask.js',
    // '~/plugins/gtag.js',
    '~plugins/phone-format.js',
    '~plugins/number-format.js',
    '~plugins/seoMetaHelper.js',
    '~plugins/get-cookies-opt.js',
    '~plugins/route.client.js',
    '~plugins/yandex-commerce.js',
    '~plugins/product-sku.js',
    '~plugins/vue-multiselect.js',
    '~plugins/get-product-name.js',
    '~/node_modules/sitis-nuxt/plugins/sitis-img.js',
  ],

  // Build Configuration: https://go.nuxtjs.dev/config-build

  // Modules for dev and build (recommended): https://go.nuxtjs.dev/config-modules
  buildModules: [
    '@nuxt/typescript-build',
  ],
  // Modules: https://go.nuxtjs.dev/config-modules
  modules: [
    'cookie-universal-nuxt',
    '@nuxt/image',
    '@nuxtjs/style-resources',
    '@nuxtjs/toast',
    // Yandex Metrika
    [
      '@rkaliev/nuxtjs-yandex-metrika',
      {
        // debug: true,
        id: 13484530,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        disabled: Boolean(process.env.ENVIRONMENT !== 'production'),
      },
    ],
    ['~/node_modules/sitis-nuxt/lib', {
      baseUrl: BASE_API_URL,
      // cmsRoot: 'cms' - default
    }],
    ['@nuxtjs/redirect-module', { statusCode: 301 }],
  ],
  image: imageProvider(BASE_API_URL),
  // '@nuxtjs/toast' config
  toast: {
    position: 'top-right',
    duration: 3000,
  },
  components: false,

  render: {
    bundleRenderer: {
      shouldPreload: (file, type) => ['font', 'script', 'style'].includes(type),
    },
  },
  build: {
    extend: function (config, { isClient }) {
      if (isClient) {
        config.devtool = 'source-map';
      }
    },
    filenames: {
      img: `[path][name].[ext]?v=${version}`,
      app: `[name].modern.js?v=${version}`,
      chunk: `[name].modern.js?v=${version}`,
      font: '[path][name].[ext]',
      css: `[name].css?v=${version}`,
    },
    extractCSS: false,
    optimization: {
      runtimeChunk: 'single',
      splitChunks: {
        chunks: 'all',

        maxInitialRequests: Infinity,
        minSize: 0,
        cacheGroups: {
          vendor: {
            test: /[\\/]node_modules[\\/]/,
            name: function (module) {
              const packageName = module.context.match(/[\\/]node_modules[\\/](.*?)([\\/]|$)/)[1];
              return `npm.${packageName.replace('@', '')}`;
            },
          },
        },
      },
    },
  },

  router: {
    extendRoutes(routes, resolve) {
      routes.unshift({
        path: '/service-calculator',
        components: {
          default: resolve(__dirname, 'pages/service-calculator/_.vue'),
        },
        chunkNames: {
          default: 'service-calculator-index',
        },
      });

      routes = routes.sort((a, b) => {
        if (a.path < b.path) {
          return 1;
        }
        if (a.path > b.path) {
          return -1;
        }
        return 0;
      });
    },
  },

  env: {
    personalDataPageUrl: process.env.PERSONAL_DATA_PAGE_URL || '/personal-data',
    copyingMaterialsPageUrl: process.env.COPYING_MATERIALS_PAGE_URL || '/copying-materials',
    linkPrivacy: process?.env?.LINK_PRIVACITY || '/privacy-politic',
    yandexReviewsWidgetId: process?.env?.YANDEX_REVIEWS_WIDGET_ID || '18384588790',
    buildTimestamp: process?.env?.BUILD_TIMESTAMP || '',
  },

  redirect,
};
